import React, { useState } from "react"
import PropTypes from 'prop-types'
import 'react-drawer/lib/react-drawer.css';
import { connect } from "react-redux"
import { Link, useHistory } from "react-router-dom"
// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions"

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown"
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

import logo from "../../assets/images/logos/1.png"

//i18n
import { withTranslation } from "react-i18next"
import cookieHelper from "helpers/getCookieData";
import { getUserRole, isAdminUser, isSuperAdminUser } from "helpers/permissionHelper";

const Header = props => {
  const [isSearch, setSearch] = useState(false)
  const history = useHistory();
  const role = getUserRole();
  const isSuper = isSuperAdminUser();
  const isPatient = role === 'patient';
  const canUseShortcuts = !isPatient && !isSuper && (['admin', 'doctor', 'receptionist', 'staff'].includes(role) || Boolean(role));

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  const cookie = cookieHelper.getCookie("_c");
  let clinicData = [];
  if (cookie && atob(cookie) != "undefined") {
    try {
      clinicData = JSON.parse(atob(cookie));
    } catch (e) {
      console.error("Invalid _c cookie:", e);
      clinicData = [];
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          {/* Left: Logo */}
          <div className="d-flex align-items-center">
            {isPatient ? (
              <Link to="/portal" className="d-flex align-items-center py-2 text-decoration-none">
                <img src={logo} alt="Dental OPD" height="48" className="d-inline-block ms-4" style={{ objectFit: 'contain' }} />
              </Link>
            ) : (
              <div className="navbar-brand-box">
                <Link to="/" className="logo">
                  <span className="logo-lg">
                    <img src={logo} alt="" height="48" />
                  </span>
                </Link>
              </div>
            )}

            {!isPatient && (
              <>
                <button
                  type="button"
                  className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
                  data-toggle="collapse"
                  onClick={() => {
                    props.toggleLeftmenu(!props.leftMenu)
                  }}
                  data-target="#topnav-menu-content"
                >
                  <i className="fa fa-fw fa-bars" />
                </button>

                <form className="app-search d-none d-lg-block">
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </>
            )}
          </div>

          {/* Right Controls */}
          <div className="d-flex align-items-center gap-1">
            {isPatient ? (
              <>
                <LanguageDropdown />
                <NotificationDropdown />
                <Link
                  to="/logout"
                  className="btn btn-outline-danger font-size-12 rounded-circle p-0 ms-1 d-flex align-items-center justify-content-center shadow-2xs me-2"
                  style={{ width: '28px', height: '28px' }}
                  title={props.t("Logout") || "Logout"}
                >
                  <i className="bx bx-power-off font-size-17" />
                </Link>
              </>
            ) : (
              <>
                <div className="dropdown d-inline-block d-lg-none ms-2">
                  <button
                    type="button"
                    className="btn header-item noti-icon "
                    id="page-header-search-dropdown"
                    onClick={() => setSearch(!isSearch)}
                  >
                    <i className="mdi mdi-magnify" />
                  </button>
                  <div
                    className={
                      isSearch
                        ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                        : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                    }
                    aria-labelledby="page-header-search-dropdown"
                  >
                    <form className="p-3">
                      <div className="form-group m-0">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.t("Search") + "..."}
                            aria-label="Recipient's username"
                          />
                          <div className="input-group-append">
                            <button className="btn btn-primary" type="submit">
                              <i className="mdi mdi-magnify" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Quick Action Shortcuts: Add Patient & Book Slot (For Admin, Doctor, Receptionist) */}
                {canUseShortcuts && (
                  <div className="d-flex align-items-center gap-2 me-2">
                    <Link
                      to="/patients?action=add"
                      className="btn btn-sm btn-outline-dark d-inline-flex align-items-center gap-1 font-size-12 px-2.5 py-1 rounded-pill font-weight-semibold shadow-2xs text-decoration-none"
                      title={props.t("Add New Patient") || "Add Patient"}
                    >
                      <i className="bx bx-user-plus font-size-14" />
                      <span className="d-none d-md-inline">{props.t("Add Patient") || "Add Patient"}</span>
                    </Link>

                    <Link
                      to="/appointments?action=book"
                      className="btn btn-sm btn-primary d-inline-flex align-items-center gap-1 font-size-12 px-2.5 py-1 rounded-pill font-weight-semibold shadow-2xs text-decoration-none"
                      title={props.t("Book Appointment Slot") || "Book Slot"}
                    >
                      <i className="bx bx-calendar-plus font-size-14" />
                      <span className="d-none d-md-inline">{props.t("Book Slot") || "Book Slot"}</span>
                    </Link>
                  </div>
                )}

                {isSuper && (
                  <div className="d-flex align-items-center me-2">
                    <Link
                      to="/superadmin"
                      className="btn btn-sm font-size-12 rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1.5 font-weight-bold shadow-2xs text-dark text-decoration-none"
                      style={{ backgroundColor: 'rgba(248, 202, 21, 0.25)', border: '1px solid #F8CA15' }}
                      title="Open SuperAdmin Command Center"
                    >
                      <i className="bx bx-shield-quarter font-size-15 text-dark" />
                      <span className="d-none d-md-inline">SuperAdmin Center</span>
                    </Link>
                  </div>
                )}

                {clinicData?.clinic_name && !isSuper && (
                  <div className="d-none d-lg-flex align-items-center me-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-dark font-size-12 rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1.5 font-weight-semibold shadow-2xs"
                      onClick={() => {
                        cookieHelper.deleteCookie("_c");
                        localStorage.setItem('clinic', '');
                        history.push("/clinics?switch=1");
                      }}
                      title="Switch Clinic Workspace"
                    >
                      <i className="bx bx-clinic font-size-14" style={{ color: '#ca8a04' }} />
                      <span className="text-truncate" style={{ maxWidth: '140px' }}>{clinicData.clinic_name}</span>
                      <i className="bx bx-chevron-down font-size-14 text-muted" />
                    </button>
                  </div>
                )}
                <LanguageDropdown />

                <div className="dropdown d-none d-lg-inline-block ms-1">
                  <button
                    type="button"
                    className="btn header-item noti-icon "
                    onClick={() => {
                      toggleFullscreen()
                    }}
                    data-toggle="fullscreen"
                  >
                    <i className="bx bx-fullscreen" />
                  </button>
                </div>

                <NotificationDropdown />
                <ProfileMenu />
              </>
            )}
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout
  return { layoutType, showRightSidebar, leftMenu }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header))
